/** Turns a multiline text into an array */
export default function lineSeparatedValues(text = "") {
  return Array.isArray(text)
    ? text
    : (text?.split("\n") ?? [])
        .map((part) => part.trim())
        .filter((part) => part?.length > 0);
}
